import Styled from 'styled-components'
import PropTypes from 'prop-types'

const Center = Styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  ${props => (props.fillParent ? 'height: 100%;' : null)}
  ${props => (props.fillParent ? 'width: 100%;' : null)}
`

Center.defaultProps = {
  fillParent: false
}

Center.propTypes = {
  fillParent: PropTypes.bool
}

export default Center
